// Entry point for frontend/browser environments
// Excludes Node.js-specific modules (otel-instrumentation) to avoid importing grpc/tls dependencies
export * from './src/config'
export * from './src/faro-injector'
